<template>
  <div>
    <div class="grid-x grid-padding-x">
      <div class="cell small-12">
        <div class="bordered pad">
          <h1>
            Manage Resources
            <router-link
              class="button float-right"
              to="/add-resource">Add Resource</router-link>
          </h1>
        </div>
      </div>
    </div>
    <div class="grid-x grid-padding-x pad-top">
      <div class="cell small12">
        <div class="bordered pad">
          <table style="width: 100%">
            <thead>
              <tr>
                <th class="text-left">Resource</th>
                <th class="text-left">Title</th>
                <th class="text-left" style="width: 75px">Display Order</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(resource, index) in resources"
                v-bind:key="index">
                <td>
                  <a :href="resource.uri" target="_blank">{{ resource.title }}</a>
                </td>
                <td style="padding-right: 20px">
                  <input
                    type="text"
                    v-model="resource.title">
                </td>
                <td>
                  <input
                    step="1"
                    type="number"
                    v-model.number="resource.display_order">
                </td>
                <td class="text-right">
                  <span @click="saveResource(index)" class="button">Save</span>
                  &nbsp;&nbsp;
                  <span @click="deleteResource(index)" class="button">Delete</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div
      v-if="message.length > 0"
      class="message-wrap">
      <span class="close-message" v-on:click="reload()">X</span>
      <p class="message-text">{{ message }}</p>
    </div>
  </div>
</template>

<script>
import axios from '../axios';

export default {
  name: 'ManageResources',
  computed: {
    authData() {
      return this.$store.getters.authData;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    userLevel() {
      return this.$store.getters.userLevel;
    },
    courseChosen() {
      return this.$store.getters.courseChosen;
    },
  },
  data() {
    return {
      message: '',
      resources: [],
    };
  },
  methods: {
    deleteResource(index) {
      const resource = this.resources[index];
      axios.get(`/resources/delete/${resource.id}.json?auth=${this.authData.token}&user=${this.authData.userId}&cage=${this.authData.cage}&level=${this.userLevel}`)
        .then((response) => {
          if (response.data.result === true) {
            this.resources.splice(index, 1);
          }
        });
    },
    getResources() {
      axios.get(`/resources/getAll/${this.courseChosen}.json?auth=${this.authData.token}&user=${this.authData.userId}&cage=${this.authData.cage}&level=${this.userLevel}`)
        .then((response) => {
          this.resources = response.data.resources;
        });
    },
    reload() {
      // eslint-disable-next-line
      location.reload();
    },
    saveResource(index) {
      const resource = this.resources[index];
      axios.post(`/resources/update.json?auth=${this.authData.token}&user=${this.authData.userId}&cage=${this.authData.cage}&level=${this.userLevel}`, resource)
        .then((response) => {
          this.message = response.data.message;
        });
    },
  },
  watch: {
    courseChosen() {
      this.resources = [];
      this.getResources();
    },
  },
  mounted() {
    this.getResources();
  },
};
</script>
